import _ from "lodash";

import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { getRelativePath } from "Utils";
import Overview from "./routes/Overview";
import CandidateInfo from "./routes/CandidateInfo";
import Subjects from "./routes/Subjects";
import ExamDetails from "./routes/ExamDetails";
import Setup from "./routes/Setup";
import RegisterCandidates from "./routes/RegisterCandidates";
import StudentMembership from "./routes/StudentMembership";

export default store => ({
  path: ":examRegId",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "ibis-registration-details" */ "./components"
        ),
        import(
          /* webpackChunkName: "ibis-registration-details" */ "DPExamRegistration/modules/DPExamRegistrationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "dpExamReg",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const lastRoute = _.last(nextState.routes);
    if (lastRoute.path === ":examRegId") {
      const childRoutes = _.get(lastRoute, "childRoutes", []);
      replace(getRelativePath(_.get(_.first(childRoutes), "path", "../")));
    }
  },
  childRoutes: [
    Overview(store),
    CandidateInfo(store),
    Subjects(store),
    ExamDetails(store),
    Setup(store),
    RegisterCandidates(store),
    StudentMembership(store),
  ],
});
